import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, Subscription, concatMap, tap } from 'rxjs';
import { of } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Tracking_Source } from '../enum/tripreplayconfig.enum';
import { ToastService } from 'mis-crystal-design-system/toast';
import { error } from 'jquery';
import { CONFIG_PAYLOAD } from '../constants/configPaylod.const';
import { DateUtils } from 'src/app/utils/days-utils';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  this: any;

  constructor(private http: HttpClient, private router: Router,private toast:ToastService,private ac: ActivatedRoute) {}
  response: any;
  buid: any;
  tripId: any;
  source: any='';
  tripDetailsRes: BehaviorSubject<any> = new BehaviorSubject<any>({});
  locationListRes: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  healthLogRes: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  prevHealthLogRes: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  fixedToEnd : BehaviorSubject<any> = new BehaviorSubject<any>(false);
  newShuttleStops : BehaviorSubject<any> = new BehaviorSubject<any>([]);
  employeeDetails$ :BehaviorSubject<any> = new BehaviorSubject<any>([]);
  driverOffData$ :BehaviorSubject<any> = new BehaviorSubject<any>([]);
  tripMetaData$ :BehaviorSubject<any> = new BehaviorSubject<any>([]);
  deviceEventsData$:BehaviorSubject<any> = new BehaviorSubject<any>([])
  driverFixedDevice:boolean = false;
  disabledFixedDeviceToggle:boolean = true;
  noDeviceFound:boolean = false;
  timeZone:string = 'Asia/Kolkata'
  deviceIMEI:string = ''
  tripTimings:any = {
    actualStartTime:0,
    actualEndTime:0,
    plannedStartTime:0,
    plannedEndTime:0
  }
  outOfRangeMilestonesCount:number = 0;
  outOfRangeUpperBound:number = 0;
  outOfRangeLowerBound:number = 0;
  callEmployeeDriverActions:any;
  noShowDriverActions:any;
  TRIP_DELAY_GRACE_MINS:number = 60 * 15 * 1000; // 15 mins
  TRIP_DELAY_LOGIN_GRACE_SECS:number;
  TRIP_DELAY_LOGOUT_GRACE_SECS:number;
  EMPLOYEE_GRACE_TIME_MIN:number;
  goToTripView() {
    if(window.location.href.includes('trip-replay-cab'))
    {
      {
        this.router.navigate(['/trip-view/cab'], {
          queryParams: { buid: this.buid, tripId: this.tripId, type:'cab',source:this.source },
        });
      }
    }
    else
    {
      this.router.navigate(['/trip-view/shuttle'], {
        queryParams: { buid: this.buid, tripId: this.tripId, type:'shuttle',source:this.source },
      });
    }

  }

  deviceDTO:any;
  getTripDetails(tripId: any) {
    return this.http.get(
      `${environment.API_URL}/tracking/buid/${this.buid}/trip/${tripId}`
    ).pipe(
      tap((res:any)=>{
        if(!res.tripDetails.vehicle.deviceDTO){
          this.noDeviceFound = true;
        }
        this.deviceIMEI = res.cabDetails.imei
        this.deviceDTO = res.tripDetails.vehicle.deviceDTO
        this.tripTimings.actualStartTime = res.tripDetails.actualStartTime
        this.tripTimings.actualEndTime = res.tripDetails.actualEndTime
        this.tripTimings.plannedStartTime = res.tripDetails.plannedStartTime
        this.tripTimings.plannedEndTime = res.tripDetails.plannedEndTime
        this.getDriverAppConfigurations().subscribe();
        this.getConfigServiceData().subscribe();
      })
    )
  }

  getDeviceHealth(date: any, deviceId: any, deviceImei: any) {
    let formattedDate = DateUtils.formatDate(date, 'DD-MM-YYYY');
    // get one day earlier too for trip sheet download time

    // For tripsheet download and display

    // let prevDate = moment(date).subtract(1, 'days').format('DD-MM-YYYY');
    // this.http
    //   .get(
    //     `${environment.API_URL}/healthlogs/?buid=${this.buid}&date=${prevDate}&deviceId=${deviceId}&deviceImei=${deviceImei}`
    //   )
    //   .subscribe(
    //     (res) => {
    //       if (res) {
    //         this.prevHealthLogRes.next(res);
    //       }
    //     },
    //     (err) => {
    //       console.log(err);
    //     }
    //   );

    return this.http.get(
      `${environment.API_URL}/healthlogs?buid=${this.buid}&date=${formattedDate}&deviceId=${deviceId}&deviceImei=${deviceImei}`
    );
  }

  getDriverActions(tripUUID?: any, tripId?: any) {
    return this.http.get(
      `${environment.API_URL}/tracking/buid/${this.buid}/get-driver-action?tripUUID=${tripUUID}&tripId=${tripId}`
    );
  }

  getTrackingSession(
    legUUID: any,
    sequenceId: any,
    cabReg: any,
    dataSource: any,
    isCompletedTrip: boolean,
    isFixedDevice: boolean,
    tripId: any
  ) {

    return this.getTimeZone().pipe(
      concatMap((res:any)=>{
        this.timeZone = res.timeZone
        return this.http.get(
          `${environment.API_URL}/tracking/buid/${this.buid}/get-tracking-data?legUUID=${legUUID}&suquenceId=${sequenceId}&imei=${cabReg}&isCompletedTrip=${isCompletedTrip}&isFixedDevice=${isFixedDevice}&tripId=${tripId}`
        )
      })
    )
 
  }

  getDriverOffData(imei, cabRegistration, startTime, endTime, buid) {
    const body = {
      imei: imei,
      cabRegistration: cabRegistration,
      startTime: startTime,
      endTime: endTime,
      buid: buid
    };
      return this.http.post(`${environment.API_URL}/cdc/devices/inactive-data`, body);
      return of(null)
  }

  getDeviceEvents(){
        const params = {
      identifiers: `${this.tripId},${this.deviceIMEI}`,
      startTime: this.tripTimings.actualStartTime,
      endTime: this.tripTimings.actualStartTime,
      tripId: this.tripId
    };
    // /centralized-dashboard/tracking/buid/stage-driverapplication/replay/device-events?identifiers=3864,317b5b39459a8bcc&startTime=1729664925341&endTime=1729672600371
    return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/replay/device-events`, { params });
  }

  getMetaData() {
    return this.http.get(
      `${environment.API_URL}/rs/trip-replay-metadata?buId=${this.buid}&tripId=${this.tripId}`
    );

  }
  
  getConfig(buid):Observable<any>
  {
      let configObservable:Observable<any> = new Observable<any>(observer=>{
          this.http.post(`${environment.API_URL}/${buid}/configurations`,CONFIG_PAYLOAD).subscribe((response)=>{
            try {
              let config=response["tracking"]['trackingSourceToggle'].split("|")
              this.driverFixedDevice=config[0]===Tracking_Source.FIXED_DEVICE;
              this.disabledFixedDeviceToggle=config.length>1
              observer.next();
              observer.complete();
            } catch (error) {
              console.log(error);
              observer.next();
              observer.complete();
            }
          },
          (error)=>{
            console.log(error);
            observer.next();
            observer.complete();
          }
          )
        });
      return configObservable
  }

  getTimeZone(){
    return this.http.get(`${environment.API_URL}/ets/${this.buid}/timeZone`);
  }

  DRIVER_APP_PROPERTIES:any = {}
  getDriverAppConfigurations(){
    if (!this.deviceDTO) {
      this.deviceDTO = {};
    }
    this.deviceDTO['BUID'] = this.buid
    return this.http.post(`${environment.API_URL}/device/properties`,this.deviceDTO).pipe(
      tap((res:any) => this.DRIVER_APP_PROPERTIES = res)
    )
  }

  overSpeedingThreshold:number;
  graceTime:number;
  getConfigServiceData(){
    const API_URL = environment.API_URL;
    const isProd = environment.production;
    const key = 'OVER_SPEEDING'
    return isProd ? 
    this.http.get(`${API_URL}/config/configurations/buid/${this.buid}/${key}`)
    .pipe(
      // tap((res:any) => this.overSpeedingThreshold = res.overspeedingTimeLimit + res.dashboardOverspeedingTimeLimitInTripLeg)
      tap((res:any) => {
        this.overSpeedingThreshold = res.overspeedingSpeedLimitInTripLeg
        this.graceTime = res.overspeedingTimeLimit + res.dashboardOverspeedingTimeLimitInTripLeg
      })
    )
    :
    this.http.get(`${API_URL}/config/configurations-v2/buid/${this.buid}/name/${key}/config`)
    .pipe(
      tap((res:any) => {
        this.overSpeedingThreshold = res.overspeedingSpeedLimitInTripLeg
        this.graceTime = res.overspeedingTimeLimit + res.dashboardOverspeedingTimeLimitInTripLeg
      })
    )
  }
}
